module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ScheduleSwitcher', {
    attrs: {
      "open-view": _vm.scheduleSwitcherView,
      "timeslots": _vm.timeslots,
      "timeslot": _vm.timeslot,
      "speaker": _vm.speaker,
      "track": _vm.track,
      "sessions": _vm.sessions,
      "speakers": _vm.speakers,
      "breakout-tracks": _vm.breakoutTracks
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78bd457c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/modals/ScheduleModal.vue
// module id = 74
// module chunks = 1